import { take, fork, put, call} from 'redux-saga/effects'
import { request, jumpToOAuth2 } from '../utils/request'


export function *searchUserInfo() {
  const result = yield call(request, `/users/current`);
  if (result && !result.error){
    yield put({type: 'session/getUserinfo', result})
  }
}

export function *deleteSession() {
  yield take('session/delete');
  yield call(request, `/session`,{method: 'delete'});
  const result = yield call(request,`${global.ssoCfg.endPoint}/session`,{method: 'delete'});
  if (result.status === 'success'){
    jumpToOAuth2()
  }
}

export function *onGetNavigationList() {

  yield put({
    types: ['navigation/onGetNavigationListLoad','navigation/onGetNavigationListSuc','navigation/onGetNavigationListErr'],
    promise: request(`/categories`),
  })
}

export function *getBackgroundImage() {
  yield put({
    type: 'session/getBackground',
    promise: request(`/theme`),
  })
}

// export function *getNews_list() {
//   yield put({
//     type: 'news/onGetNewsListSuc',
//     promise: request('/news_list')
//   })
// }
//
// export function *getNews_pic() {
//   yield put({
//     type: 'news/onGetNewsPicSuc',
//     promise: request('/slide_list')
//   })
// }


// WEBPACK FOOTER //
// ./src/sagas/session.js